module.exports = __webpack_public_path__ + "public/1.0.1_009961/img/client.c10e044a.svg";